module.exports = __webpack_public_path__ + "static/media/m120-52.ae3f9b4c.png";